export const PRICEMULTIPLIER = 100;

export const REFERRAL_REWARD = 5;

export enum VATType {
  ZERO = 0,
  TWOPOINTONE = 2.1 * PRICEMULTIPLIER,
  FIVEPOINTFIVE = 5.5 * PRICEMULTIPLIER,
  TEN = 10 * PRICEMULTIPLIER,
  TWENTY = 20 * PRICEMULTIPLIER,
}
